import React, { Component } from "react";
//import Moment from 'react-moment';
import { css } from "aphrodite";
import { styles } from "./EnergyServicesHomeStyles";
import Header from "../components/Header";
import Loading from "../components/Loading";
import AssistedLivingNavigation from "../components/AssistedLivingNavigation";
import ApplianceTitle from "../components/ApplianceTitle";
import ApplianceBreakdown from "../components/ApplianceBreakdown";
import { applianceActions } from "../_actions";
import { connect } from "react-redux";
import { nth } from "../_helpers/helpers";
import Toggle from "react-toggle";
import "./ToggleStyles.css";
import PopupWrapper from "../components/PopupWrapper";

class AssistedLivingAppliance extends Component {
  constructor(props) {
    super(props);
    this.props.dispatch(
      applianceActions.getDetail(
        props.authentication.user.dependant_user_id,
        props.match.params.appliance_id
      )
    );
    this.state = {
      usageShowingDuration: true
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle(event) {
    this.setState({ usageShowingDuration: event.target.checked });
  }

  render() {
    const { fetchingDetail, detail } = this.props.appliance;

    let averageCost = 0,
      averageComparableCost = 0,
      averageUsage = 0,
      averageComparableUsage = 0,
      averageConsumed = 0,
      averageComparableConsumed = 0,
      totalCost = 0,
      totalComparableCost = 0;

    if (detail && detail.time_series) {
      detail.time_series.map((item, index, array) => {
        averageCost += item.appliance && item.appliance.cost;
        averageComparableCost += item.comparable && item.comparable.cost;
        averageUsage += item.appliance && item.appliance.duration;
        averageComparableUsage += item.comparable && item.comparable.duration;
        averageConsumed += item.appliance && item.appliance.consumed;
        averageComparableConsumed += item.comparable && item.comparable.consumed;

        if (index === array.length - 1) {
          totalCost = (averageCost / averageUsage).toFixed(2);
          totalComparableCost = (averageComparableCost / averageComparableUsage).toFixed(2);
          averageCost = (averageCost / array.length).toFixed(2);
          averageComparableCost = (averageComparableCost / array.length).toFixed(2);
          averageUsage = (averageUsage / array.length).toFixed(2);
          averageComparableUsage = (averageComparableUsage / array.length).toFixed(2);
          averageConsumed = (averageConsumed / array.length).toFixed(2);
          averageComparableConsumed = (averageComparableConsumed / array.length).toFixed(2);
        }

        if (isNaN(totalCost)) {
          totalCost = 0;
          totalCost = totalCost.toFixed(2);
        }

        return false;
      });
    }

    return (
      <div>
        <Header
          title={"Appliance"}
          backTitle={"Parent's Home"}
          isAssistedLiving={true}
          backHref={"/parents-home"}
        />
        <AssistedLivingNavigation {...this.props.location} />
        <div className={css(styles.container)}>
          <PopupWrapper />
          {fetchingDetail && <Loading />}
          {!fetchingDetail && detail.currency_unit && (
            <div>
              <ApplianceTitle {...detail} app="infocare" />
              <h3 className={css(styles.breakdownTitle)}>Cost Breakdown</h3>
              <ApplianceBreakdown {...detail} title="Cost" value="cost" />
              <ul className={css(styles.ul)}>
                <li className={css(styles.li)}>
                  {`Average cost of `}
                  <span
                    className={css(styles.highlightCost)}
                  >{`${detail.currency_unit}${averageCost}`}</span>
                  {` per day`}
                </li>
                <li className={css(styles.li)}>{`Your ${detail.appliance_rankings.cost}${nth(
                  detail.appliance_rankings.cost
                )} most costly appliance, out of ${detail.appliance_rankings.out_of}`}</li>
                <li
                  className={css(styles.li)}
                >{`${detail.currency_unit}${totalCost} for each ${detail.time_unit} used`}</li>
              </ul>
              <div className={css(styles.similarCost)}>
                <h5
                  className={css(styles.similarTitle)}
                >{`Other similar people's ${detail.name}...`}</h5>
                <ul className={css(styles.ulWhite)}>
                  <li
                    className={css(styles.li)}
                  >{`Average cost of ${detail.currency_unit}${averageComparableCost} per day`}</li>
                  <li className={css(styles.li)}>{`Their ${detail.comparable_rankings.cost}${nth(
                    detail.comparable_rankings.cost
                  )} most costly appliance`}</li>
                  <li
                    className={css(styles.li)}
                  >{`${detail.currency_unit}${totalComparableCost} for each ${detail.time_unit} used`}</li>
                </ul>
              </div>
              <h3 className={css(styles.breakdownTitle)}>
                <span className={css(styles.breakdownTitleText)}>Usage Breakdown</span>
                <div className={css(styles.breakdownToggle)}>
                  <strong className={css(styles.breakdownToggleTitle)}>Show:</strong>
                  <span className={css(styles.breakdownToggleUnit)}>kWh</span>
                  <label className={css(styles.breakdownToggleLabel)}>
                    <Toggle
                      defaultChecked={this.state.usageShowingDuration}
                      icons={false}
                      onChange={this.handleToggle}
                    />
                  </label>
                  <span className={css(styles.breakdownToggleUnit)}>Minutes</span>
                </div>
              </h3>
              {this.state.usageShowingDuration && (
                <div>
                  <ApplianceBreakdown {...detail} title="Usage" value="duration" />
                  <ul className={css(styles.ul)}>
                    <li className={css(styles.li)}>
                      {`Average usage of `}
                      <span
                        className={css(styles.highlightUsage)}
                      >{`${averageUsage} ${detail.time_unit}s`}</span>
                      {` per day`}
                    </li>
                    <li className={css(styles.li)}>{`Your ${
                      detail.appliance_rankings.duration
                    }${nth(detail.appliance_rankings.duration)} most used appliance, out of ${
                      detail.appliance_rankings.out_of
                    }`}</li>
                  </ul>
                  <div className={css(styles.similarUsage)}>
                    <h5
                      className={css(styles.similarTitle)}
                    >{`Other similar people's ${detail.name}...`}</h5>
                    <ul className={css(styles.ulWhite)}>
                      <li
                        className={css(styles.li)}
                      >{`Average usage of ${averageComparableUsage} ${detail.time_unit}s per day`}</li>
                      <li className={css(styles.li)}>{`Their ${
                        detail.comparable_rankings.duration
                      }${nth(detail.comparable_rankings.duration)} most used appliance`}</li>
                    </ul>
                  </div>
                </div>
              )}
              {!this.state.usageShowingDuration && (
                <div>
                  <ApplianceBreakdown {...detail} title="Usage" value="consumed" />
                  <ul className={css(styles.ul)}>
                    <li className={css(styles.li)}>
                      {`Average usage of `}
                      <span
                        className={css(styles.highlightUsage)}
                      >{`${averageConsumed} ${detail.energy_unit}`}</span>
                      {` per day`}
                    </li>
                    <li className={css(styles.li)}>{`Your ${
                      detail.appliance_rankings.consumption
                    }${nth(
                      detail.appliance_rankings.consumption
                    )} highest consuming appliance, out of ${
                      detail.appliance_rankings.out_of
                    }`}</li>
                  </ul>
                  <div className={css(styles.similarUsage)}>
                    <h5
                      className={css(styles.similarTitle)}
                    >{`Other similar people's ${detail.name}...`}</h5>
                    <ul className={css(styles.ulWhite)}>
                      <li
                        className={css(styles.li)}
                      >{`Average usage of ${averageComparableConsumed} ${detail.energy_unit} per day`}</li>
                      <li className={css(styles.li)}>{`Their ${
                        detail.comparable_rankings.consumption
                      }${nth(
                        detail.comparable_rankings.consumption
                      )} highest consuming appliance`}</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { fetchingDetail } = state.appliance;
  const { alert } = state;
  const appliance = state.appliance;
  const authentication = state.authentication;
  return {
    fetchingDetail,
    alert,
    appliance,
    authentication
  };
}

export default connect(mapStateToProps)(AssistedLivingAppliance);
